import { render, staticRenderFns } from "./DeptcargoTbale.vue?vue&type=template&id=76e1ab56&scoped=true"
import script from "./DeptcargoTbale.vue?vue&type=script&lang=js"
export * from "./DeptcargoTbale.vue?vue&type=script&lang=js"
import style0 from "./DeptcargoTbale.vue?vue&type=style&index=0&id=76e1ab56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e1ab56",
  null
  
)

export default component.exports